import React from 'react'

import popTestImg from '../../images/pop-2-img.png'
import DelImg from '../../images/delete.png'
import './Model.css'
const ModelTest = ({closeModelTest}) => {
  return (
    <div className='model-main'>
      <div className="model">

        <div className="pop-head">
          <h5>Test Logs</h5>
         <img src={DelImg} onClick={()=> closeModelTest(false)} alt="" />
        </div>
        <div className="pop-body">
          <div className="pop-sidebar">
            <button>Log 1</button>
            <button>Log 2</button>
          </div>
          <div className="pop-main">
            <div className="popTest-img">
              <img src={popTestImg} alt="" />
            </div>
            {/* <div className="pop-main-btn">
            <button>Date</button>
            <button>User</button>
            <button>States</button>
            </div> */}
          </div>
        </div>

      </div>
    </div>

  )
}

export default ModelTest;